import { render, staticRenderFns } from "./ListsSection.vue?vue&type=template&id=0ba4b0e0&scoped=true&"
import script from "./ListsSection.vue?vue&type=script&lang=ts&"
export * from "./ListsSection.vue?vue&type=script&lang=ts&"
import style0 from "./ListsSection.vue?vue&type=style&index=0&id=0ba4b0e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4b0e0",
  null
  
)

export default component.exports